export class document {
  public name: string = "";
  public url: string = "";
}
